import { Controller } from "@hotwired/stimulus"

// Auto-opens the bank-app deep link (e.g. vcbpartner://…) once on touch devices,
// where the custom scheme actually resolves to an installed app. Desktop browsers
// silently ignore it, so they keep the always-visible QR + button as the path.
export default class extends Controller {
  static values = { url: String }

  connect() {
    // Keyed by the deep link itself: a fresh link request mints a new token/url,
    // so cancel-and-retry auto-opens again, but a re-render of the same pending
    // request (poll refresh, back nav) must not yank the owner into the app again.
    if (window.matchMedia("(pointer: coarse)").matches && !sessionStorage.getItem(this.urlValue)) {
      sessionStorage.setItem(this.urlValue, "1")
      window.location.href = this.urlValue
    }
  }
}
